module.exports = __webpack_public_path__ + "img/170.a932cc00.jpg";